import React, { Component } from "react";
import { Link } from 'react-router-dom'
import { Button, ButtonGroup, PageHeader, PanelGroup, Panel } from "react-bootstrap";
import { getMeasureTitle }            from "../../utils/Measure";
import YouTubeThumbnail               from "../../components/YouTubeThumbnail";
import WorkoutFinishedBox             from "../../components/workout/WorkoutFinishedBox";
import LoaderButton                   from "../../components/LoaderButton";
import ModalLoadingInfo               from "../../components/modal/ModalLoadingInfo";
import { invokeGetProgramDayWorkout } from "../../utils/AwsInvoke";
import { WhiteLabel }                 from "../../utils/WhiteLabelProps";
import { Steps, Hints }               from "intro.js-react"; // js code for welcome tour

import "intro.js/introjs.css"; // css for welcome tour
import "../../css/workout/Workout.css";

var white_label = WhiteLabel();
const MainColor                 = white_label.company_primary_btn_color;
const AWSUrl                    = white_label.aws_athlete_assets_url;
const posture_health_company_id = "69c4ac91-69b7-11ea-b027-a3b6eeba595f";

// Can't add in SetState otherwise there's an endless loop
// Below is a temp solution, replace shortly
var workout_box_overlay = "none";

export default class ProgramDayWorkout extends Component {
    constructor(props) {
        super(props);

        // Breaking up WEEK and DAY in case we need to get a program's day_id
        // for duplicating a day's data from an athlete marketplace's program
        var week_day = `${this.props.match.params.week_tracker}`;
        var week = week_day.substring(0, 1);
        var day = week_day.substring(2, 3);

        var curr_week_day = "Week " + week + ", Day " + day;

        this.state = {
            active_key: 2,
            isLoading: true,
            title:        `${this.props.match.params.title}`,
            program_id:   `${this.props.match.params.program_id}`,
            day_id:       `${this.props.match.params.day_id}`,
            week_tracker:  curr_week_day,
            curr_week:     week,
            curr_day:      day,
            showModalLoadingInfo:  true,
            mktplc_program_id: `${this.props.match.params.mktplc_program_id}`,
            list: [],
            pageOverlay: "none",

            // Help Tour //
            stepsEnabled: false,
            initialStep: 0,
            steps: [
                {
                  element: ".programDayWorkoutExerciseButtonBarProductTour",
                  intro: "Select a \"view\" and how you would like to see your workout. <b>\"View Single Exercise\"</b> shows you one exercise at a time.  <b>\"View All Exercises\"</b> shows all exercises on one screen.",
                  position: 'left'
              },
                {
                  element: ".programDayWorkoutExerciseDetailProductTour",
                  intro: "Click to begin working out on the selected exercise.",
                  position: 'auto'
                }
            ],
        };

        this.handleWorkoutDetails = this.handleWorkoutDetails.bind(this);
        this.getCountOfSetIds     = this.getCountOfSetIds.bind(this);
        this.getCountOfTotalSets  = this.getCountOfTotalSets.bind(this);
    }

    async componentDidMount() {

        if (!this.props.isAuthenticated) {
            return;
        }

        try {
          this.setState({
                showModalLoadingInfo: true // show "Congrats Subscription" Modal
          });

            workout_box_overlay  = "none"; // reset page overlay
            this.renderSubProgramList();
        } catch (e) {
            alert(e);
        }

        this.setState({ isLoading: false });
    }

    setOverlayState (overlay) {

        if(overlay === "no_overlay") {
            this.setState({
                pageOverlay : "none"
            })
        } else if(overlay === "overlay") {
            this.setState({
                pageOverlay : "inline"
            })
        }
    }

    async renderSubProgramList() {
        var user_id = this.props.globalUserId;
        this.setOverlayState("no_overlay");

        var day_id     = this.state.day_id;
        var program_id = this.state.program_id;
        var title      = this.state.title;
        var mktplc_program_id = this.state.mktplc_program_id;
        var curr_week  = this.state.curr_week;
        var curr_day   = this.state.curr_day;

        var results = await invokeGetProgramDayWorkout(user_id, mktplc_program_id, program_id, day_id, curr_week, curr_day);
        // temp stop: var data = "stop";//
        var data = results.data;

        if(results.status) {
                // Default setting
                var title = this.state.title;
                //var image = "cardio1.jpg"
                var panel_key = 1;

                /*if(data.name[0] != undefined) {
                    title = data.name[0].name;
                    image = data.name[0].image;
                }*/
                console.log("***** data.completed_blocks: " + data.completed_blocks);

                var block_ids = data.block_ids;
                var cb_lgth = data.completed_blocks.length;
                var bl_lgth = data.block_ids.length;
                panel_key  = cb_lgth + 1;

                // Ensure active key is not higher than the number of actual panels.
                if(cb_lgth >= bl_lgth) panel_key = cb_lgth;

                this.setState({
                    name: title,
                    active_key: panel_key,
                    block_ids: data.block_ids,
                    block_names: data.block_names, // multi-dim array [block_id, block_name]
                    set_ids:  data.set_ids,
                    completed_set_ids: data.completed_set_ids,
                    count_total_sets: data.count_total_sets,
                    completed_blocks: data.completed_blocks,
                    showModalLoadingInfo: false // show "Congrats Subscription" Modal
                })
         }
    }

    renderProgramsList() {
            var program_id = this.state.program_id;
            var title      = this.state.title;
            var day_id     = this.state.day_id;
            var week_tracker = this.state.week_tracker;
            var curr_week    = this.state.curr_week;
            var curr_day     = this.state.curr_day;
            var image2;
            var company_id     = localStorage.getItem('globalUserCompanyId');

            var cover_image = localStorage.getItem('coverImage');

            if(cover_image != undefined)
                image2 = <img src={ cover_image } width="100%"/> //require(`../../images/program_categories/`+image)

            //var summary    = list[0].summary;
            //var difficulty_level = list[0].difficulty_level;
            //var char_count = difficulty_level.toString().length;
            //if(char_count === 1) difficulty_level = difficulty_level + ".0";

            var programs = <span className="summaryContainer" >
                                    <span className="programBeginImage" style={{backgroundColor: "#666"}}>
                                         { image2 }
                                    </span>
                                    <span className="programWorkoutFadeImage">
                                        <img src={require('../../images/utils/program_category_black_fade2.png')} height="105" width="100%"/>
                                    </span>
                                    <span className="programWorkoutTitle"
                                          href={`/ProgramBegin/${program_id}/${title}`}
                                          onClick={this.handleWorkoutDetails}
                                          style={{whiteSpace: "nowrap", overflowX:"hidden", color: "#fff"}}
                                          >
                                          {title}
                                    </span>
                                    <span className="programWorkoutDateTitle"
                                          style={{position: "absolute", top:57,left:0, fontSize:"24px", color: "#fff"}}
                                          >
                                          {week_tracker}
                                    </span>
                                    <div className=""
                                         style={{position:"relative", top: 105, zIndex:1000}}>
                                            <ButtonGroup size="lg"
                                                         style={{width:"100%", position:"relative", top:0, left: -10}}
                                                         className="workoutOverviewLink dayViewBtnGroup dayViewFlex programDayWorkoutExerciseButtonBarProductTour">
                                                <Button className="active buttonWorkoutMode dayViewBtn">
                                                    View Single Exercise
                                                </Button>
                                                <Button href={`/workoutallexercises/${program_id}/${day_id}/${title}/${curr_week}-${curr_day}`}
                                                        className="buttonWorkoutMode dayViewBtn"
                                                        onClick={this.handleExerciseMetrics}>
                                                    View All Exercises
                                                </Button>
                                                { /*}<Button className="buttonWorkoutMode dayViewBtn">
                                                    Grid View <span style={{fontSize:10}}>(coming...)</span>
                                            </Button>*/ }
                                            </ButtonGroup>
                                    </div>
                                    <span className="programWorkoutBox">
                                         { this.renderBlockList() }
                                    </span>
                            </span>
        //}

        return programs;
    }
    handleExerciseMetrics = event => {
        event.preventDefault();
        var href = event.currentTarget.getAttribute("href");
        this.props.history.push(href);
    }

    handleWorkoutDetails = event => {
        event.preventDefault();
        var href = event.currentTarget.getAttribute("href");
        //this.props.history.push(href);
    }

    renderLander() {
        return (
          <div className="lander">
            <h1>TS</h1>
            <p></p>
          </div>
        );
    }

    handleSelect (active_key) {
        this.setState({ active_key });
    }

    renderList() {
      return (
        <div className="list">
            {!this.state.isLoading && this.renderProgramsList()}
        </div>
      );
    }


    getCountOfTotalSets = (set_id) => {
        var data = this.state.count_total_sets;
        //console.log("================= set id: " + set_id);
        var count;
        for(var key in data) {
            var data_set_id = data[key].set_id;
            //console.log("2. data_set_id: " + data_set_id);
            if(set_id == data_set_id) {
                count = data[key].max_order;
            }
        }

        //// Used to catch undefined Free-form Exercise/Note
        if(count == undefined) count = 2; // At least 1 exercise in a block = 2

        return count;
    }


    getCountOfSetIds = (set_id) => {
        var data = this.state.completed_set_ids;
        var count = 0;
        for(var key in data) {
            var data_set_id = data[key].set_id;
            //console.log("1. data_set_id: " + data_set_id);
            if(set_id == data_set_id) count++;
        }

        return count;
    }

    getExercises = (getCountOfSetIds, getCountOfTotalSets, handleWorkoutDetails, block_id, day_block_ids_arr, blocks_and_set_ids) => {
        var yt_id = "";
        var set_obj      = this.state.set_ids;
        var ctr = 0;
        var title        = this.state.title;
        var program_id   = this.state.program_id;
        var day_id       = this.state.day_id;
        var week_tracker = this.state.week_tracker;
        var curr_week    = this.state.curr_week;
        var curr_day     = this.state.curr_day;

        var exercises = Object.keys(set_obj).map(function (key) {
                        var set_key = set_obj[key];
                        var tmp_block_id = set_key.block_id;

                        if(block_id === tmp_block_id) {
                            var that            = this;
                            var name            = set_key.name;
                            var rest            = set_key.rest + " seconds";
                            var set_id          = set_key.set_id;
                            var yt_id           = set_key.youtube_id;
                            var exercise_id     = set_key.exercise_id;

                            //var measure_a       = measure_a_value + " " + getMeasureTitle(measure_a_id);
                            //if(measure_a_value === null) measure_a = "4 Sets out of 10";

                            /*var measure_b_id    = set_key.measure_b_id;
                            var measure_b_value = set_key.measure_b_value;
                            var measure_b       = measure_b_value + " " + getMeasureTitle(measure_b_id);
                            if(measure_b_value === null) {
                                measure_b = "Reps";
                                rest      = "Variable "
                            } */

                            var bgColor = "#f1f1f1";
                            if (ctr%2 == 0) bgColor = "white";

                            var compl_text = "Finished: "

                            var count       = getCountOfSetIds(set_id);
                            var total_count = getCountOfTotalSets(set_id);
                            // 4 of 3 sets now equals 3 of 3 sets
                            if(count > total_count) count = total_count;

                            var yt_container   = <YouTubeThumbnail yt_id={yt_id} width={100}/>
                            var set_compl_text = compl_text + count + " of " + total_count + " sets";
                            var img_checkmark;
                            ctr++;

                            if(yt_id == "" || name === "Free-Form")
                                yt_container = <img src={require('../../images/utils/thumb_template.png')} width="100"/>;

                            if(name === "Free-Form") {
                                // nullify vars since freeform doesnt have them
                                set_compl_text = "Custom Sets";
                                img_checkmark  = "";
                            }

                            if(count >= total_count)
                                img_checkmark = <img src={require('../../images/utils/checkmark_green.png')} width="16"/>

                            return ( <Panel.Body collapsible
                                                 key     = {key}
                                                 style   = {{backgroundColor: bgColor, padding:0, cursor: "pointer" }}
                                                 onClick = {handleWorkoutDetails}
                                     >
                                        <Link to={{ pathname: `/workoutDetail/${title}/${program_id}/${block_id}/${set_id}/${day_id}/${curr_week}-${curr_day}/`,
                                                    state: {day_block_ids: day_block_ids_arr, blocks_and_set_ids: blocks_and_set_ids } }}>
                                                <span className="workoutAccordionPanel programDayWorkoutExerciseDetailProductTour">
                                                        <span className="workoutAccordionYoutubeThumb">
                                                            { yt_container }
                                                        </span>
                                                        <span className="workoutAccordionExerciseTitle">
                                                              { name } { /*set_id*/ }
                                                        </span>
                                                        <span className="workoutAccordionExerciseRest">
                                                          <span className="glyphicon glyphicon-stats"/>&nbsp;
                                                          { set_compl_text }&nbsp; { img_checkmark }
                                                        </span>
                                                </span>
                                        </Link>
                                    </Panel.Body>
                        )}
                   });
        return exercises;

        {/*}<span className="workoutAccordionExerciseRest">
            <span className="glyphicon glyphicon-time workoutGlyphIcon"/>&nbsp;
            Rest: { rest }
        </span>*/ }
    }

    getBlockNames = (block_id) => {

        var block_names = this.state.block_names;
        var block_name  = "";
        for(var key in block_names) {
            var tmp_block_id = block_names[key][0];
            if(block_id === tmp_block_id) {
                var block_name = block_names[key][1];
                //console.log("block id: " + tmp_block_id);
                //console.log("block name: " + block_names[key][1]);
            }
        }

        return block_name;
    }

    handleWorkoutFinished = event => {
          event.preventDefault();
          var title         = this.state.title;
          var week_tracker  = this.state.week_tracker;
          var program_id    = this.state.program_id;
          var day_id        = this.state.day_id;

          this.props.history.push(`/workoutFinished/${title}/${week_tracker}/${program_id}/${day_id}`);
    }

    renderBlockList() {
        var programs    = [];
        var blocks      = this.state.block_ids;

        if(blocks != undefined) {
                var obj_lgth = Object.keys(blocks).length;
                var completed_blocks = this.state.completed_blocks;

                var set_obj              = this.state.set_ids;
                var day_block_ids_arr    = [];
                var completed_blocks_arr = [];
                var blocks_and_set_ids   = [];
                //console.log(" ------------- CHECK BLOCKS ------------------");
                //console.log("completed_blocks: " + completed_blocks);
                for(var key in completed_blocks) {
                    completed_blocks_arr.push(completed_blocks[key]);
                }

                for(var key2 in blocks) {
                    day_block_ids_arr.push(blocks[key2].block_id);
                }

                for(var key3 in set_obj) {
                    var tmp_block_id = set_obj[key3].block_id;
                    var tmp_set_id   = set_obj[key3].set_id;
                    blocks_and_set_ids.push([tmp_block_id, tmp_set_id]);
                }

                for(var i = 1; i < obj_lgth+1; i++) {
                    var ctr = i-1;
                    var block_id    = blocks[ctr].block_id;
                    var block_order = blocks[ctr].block_order;
                    var block_name  = blocks[ctr].block_name;
                    //var block_completed;// = blocks[ctr].block_id_completed;
                    var block_completed = -1;
                    var cmark          = "checkmark_gray";

                    var block_title   = "Block " + i;
                    //var blockName = this.getBlockNames(block_id);

                    if(block_name != "" && block_name != null) block_title = block_name;

                    if(completed_blocks_arr.length > 0)
                        block_completed = completed_blocks_arr.indexOf(block_id);

                    if(block_completed != -1) {
                        cmark = "checkmark_green";
                        //active_key = i+1;
                    }

                    //console.log("block_title: " + block_title);
                    //console.log("block_completed: " + block_completed);
                    //console.log("------------------------------------");
                    var all_exercises = this.getExercises(this.getCountOfSetIds, this.getCountOfTotalSets, this.handleWorkoutDetails, block_id, day_block_ids_arr, blocks_and_set_ids);

                    programs.push(  <Panel key = {i} eventKey={i} >
                                          <Panel.Heading style={{backgroundColor:"#666", position:"relative", borderRight:4, borderLeft:"0px", zIndex:5000}} >
                                              <Panel.Title className="programWorkoutPanelTitle" toggle>
                                                  <span className="programWorkoutPanelSubTitle">
                                                      {block_title} { /*block_id /* */ }
                                                   </span>
                                                   <span className="workoutDetailsPanelRight">
                                                       <img src={require('../../images/utils/'+cmark+'.png')} width="26"/>
                                                   </span>

                                              </Panel.Title>

                                          </Panel.Heading>
                                          { all_exercises }
                                    </Panel>
                        )
                }
        }

        //// Check if all Blocks are completed ////
        var blocks_compl_msg;
        var completed_blocks = this.state.completed_blocks;
        var block_ids        = this.state.block_ids;
        if(completed_blocks != undefined && block_ids != undefined) {
            var cb_lgth = completed_blocks.length;
            var bl_lgth = block_ids.length;

            if(cb_lgth >= bl_lgth) {
                workout_box_overlay = "inline";
                blocks_compl_msg = <div style={{position:"relative", marginLeft:"50%", left: -200}}>
                                        { /*}<WorkoutFinishedBox
                                            isLoading = {this.state.isLoading}
                                            handleWorkoutFinished = {this.handleWorkoutFinished}
                                       />*/ }
                                   </div>
            }
        }

        var workout = <span>
                            <PanelGroup accordion
                                      id="accordion"
                                      activeKey={this.state.active_key}
                                      onSelect={this.handleSelect.bind(this)}
                                      className="panel-group"
                                      >
                                { programs }
                            </PanelGroup>
                            <span>
                                {blocks_compl_msg}
                            </span>
                      </span>
        return workout;
    }

    closeOverlay = () => {
        workout_box_overlay = "none";
        this.setState({
            pageOverlay: "none"
        })
    }

    handleHideOverlay = event => {
        workout_box_overlay = "none"

        this.setState({
            pageOverlay: "none",
            showWorkoutBox: "none"
        })
    }

    workoutFinishedOverlay() {
        return <div style={{width:410, height: 228, borderRadius: 5, border:"2px solid #ccc", backgroundColor: "#666"}}>
                    <div style={{position:"relative", top:0}}>
                        <WorkoutFinishedBox
                              isLoading             = {this.state.isLoading}
                              handleHideOverlay     = {this.handleHideOverlay}
                              color                 = "white"
                              handleWorkoutFinished = {this.handleWorkoutFinished}
                        />
                    </div>
               </div>
    }


    ////  Begin: Show Help Tour  ////
    onStart = () => {
        this.setState({ active_key: 1 });
    };

    onExit = () => {
        this.setState(() => ({ stepsEnabled: false }));
    };

    showHelpTour = () => {
        this.setState(() => ({ stepsEnabled: true }));
    }

    ////  End: Show Help Tour  ////

    render() {
        let closeModalLoadingInfo = () => this.setState({ showModalLoadingInfo: false }); //close simple modal window
        var loading_text = "We're loading your workout data. <br/><br/><div>'Patience is bitter, but its fruit is sweet.'<div><div> &nbsp;  &nbsp;  &nbsp;  &nbsp;  &nbsp;  &nbsp;  &nbsp; &nbsp;  &nbsp;  &nbsp;  &nbsp;  &nbsp;  &nbsp;  &nbsp; &nbsp;  &nbsp;  &nbsp;  &nbsp;  &nbsp;  &nbsp;  &nbsp; &nbsp;  &nbsp;  &nbsp;  &nbsp;  &nbsp;&nbsp;&nbsp;- Aristotle</div>";

        const {
            stepsEnabled,
            steps,
            initialStep,
        } = this.state;

        return (
              <div className="HomeProgramWorkout">
                    <span className = "dashboardMainIconHelpTour glyphicon glyphicon-question-sign"
                          onClick   = {this.showHelpTour}/>
                    {this.renderList()}
                    { /*this.props.isAuthenticated ? this.renderNotes() : this.renderLander()*/ }
                    <div>
                        <span className="pageOverlay" style={{display:this.state.pageOverlay}}>
                        </span>
                        <span style={{display: this.state.showWorkoutBox}}>
                            <span style={{float:"left", position:"fixed", top:"20%", marginLeft:"50%", left:-200, display: workout_box_overlay, zIndex:10000}}>
                                  { this.workoutFinishedOverlay() }
                            </span>
                        </span>
                    </div>

                    {this.state.showModalLoadingInfo ?
                    <ModalLoadingInfo
                          modalWidth    = { 400 }
                          modalHeight   = { 200 }
                          show          = { this.state.showModalLoadingInfo }
                          message       = { loading_text }
                          //onHide = { closeModalLoadingInfo }
                      />
                    : null}

                    <Steps
                        enabled = {stepsEnabled}
                        steps   = {steps}
                        initialStep={initialStep}
                        onStart = {this.onStart}
                        onExit  = {this.onExit}
                        options = {{disableInteraction:true}}
                    />
              </div>
        );
  }
}



// WEBPACK FOOTER //
// ./src/screens/workout/ProgramDayWorkout.js